module.exports = __webpack_public_path__ + "img/logo.97cb166e.png";